module.exports = __webpack_public_path__ + "img/router_momo.9f5fea70.jpg";